<template>
  <div class="filterDate">
    <b-modal
      ref="openModal"
      class="filterDateModal"
      scrollable
      size="sm"
      :title="filterName"
      @ok="modalOk"
    >
      <label>{{ $t("geral.whatFilterMode") }}</label>
      <b-form-select
        v-model="getFilterOption"
        id="optionFilterDate"
        :options="optionsFilterDate"
        @input="onChange"
      >
      </b-form-select>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <div class="right">
      <b-button variant="link" @click="modalOpen">
        <i class="tim-icons icon-settings-gear-63 btn-filter-settings"> </i>
      </b-button>
    </div>
    <div v-if="optionFilterDate == 0">
      <b-form-input
        class="dateIndividual"
        type="date"
        v-model="getFilterFill"
      />
    </div>
    <div v-if="optionFilterDate == 1">
      <b-form-input class="fieldDate" type="date" v-model="getFilterBegin" />
      <b-form-input type="date" v-model="getFilterEnd" />
    </div>
    <div v-if="optionFilterDate == 2" class="todayDate">
      <b-form-input v-model="today" :readonly="true" />
      <!-- <label for="">Data atual</label> -->
    </div>
    <!-- <div>DateBegin: {{ dateBegin }}</div> -->
    <!-- <div>DateEnd: {{ dateEnd }}</div> -->
    <!-- {{dateFill}} -->
    <!-- <div>optionFilterDate: {{ optionFilterDate }}</div> -->
    <!-- <div>filterDate.optionFilterDate : {{ filterDate.optionFilterDate }}</div> -->
  </div>
</template>

<script>
export default {
  props: {
    dateFill: String,
    dateBegin: String,
    dateEnd: String,
    filterName: String,
    optionFilterDate: Number,
    filterDates: Array,
  },
  data: function () {
    return {
      optionsFilterDate: [
        { value: 0, text: this.$t("geral.filterDateSame") },
        { value: 1, text: this.$t("geral.filterDateRange") },
        { value: 2, text: this.$t("geral.filterDateToday") },
      ],
      todayDate: "",
      today: "Hoje",
      filterDate: {
        urlPage: "",
        optionFilterDate: 0,
        fieldName: "",
      },
    };
  },
  created() {
    if (this.filterDates) {
      if (this.filterDates.length == 0) {
        this.filterDate.urlPage = window.location.href;
        this.filterDate.optionFilterDate = this.optionFilterDate;
        this.filterDate.fieldName = this.filterName;
        this.filterDates.push(this.filterDate);
      } else {
        this.filterDates.forEach((filter) => {
          if (filter.fieldName == this.filterName) {
            this.filterDate = filter;
          }
        });
        this.$emit("update:optionFilterDate", this.filterDate.optionFilterDate);
        if (this.filterDate.optionFilterDate == 2) this.getTodayDate();
      }
    }
  },
  computed: {
    getFilterFill: {
      get: function () {
        return this.dateFill;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
        this.$emit("update:dateEnd", `${value}T23:59:59`);
      },
    },
    getFilterBegin: {
      get: function () {
        return this.dateBegin;
      },
      set: function (value) {
        this.$emit("update:dateBegin", value);
      },
    },
    getFilterEnd: {
      get: function () {
        return this.dateEnd.replace("T23:59:59", "");
      },
      set: function (value) {
        if (!value) {
          value = value.replace("T23:59:59", "");
          this.$emit("update:dateEnd", `${value}`);
        } else {
          value = value.replace("T23:59:59", "");
          this.$emit("update:dateEnd", `${value}T23:59:59`);
        }
      },
    },
    getFilterOption: {
      get: function () {
        return this.optionFilterDate;
      },
      set: function (value) {
        if (this.filterDate) {
          this.filterDate.optionFilterDate = value;
        }
        if (this.filterDates) {
          this.filterDates.forEach((filter) => {
            if (filter.fieldName == this.filterName) {
              filter.optionFilterDate = value;
            }
          });
        }
        this.$emit("update:optionFilterDate", value);
      },
    },
  },
  methods: {
    modalOpen() {
      this.$refs.openModal.show();
    },
    modalOk() {
      if (this.getFilterOption != 2) {
        this.$emit("update:dateBegin", "");
        this.$emit("update:dateEnd", "");
      }
    },
    getTodayDate() {
      let fullDate = new Date();

      let dia = fullDate.getDate();
      let mes = fullDate.getMonth() + 1;
      let ano = fullDate.getFullYear();

      if (dia < 10) dia = "0" + dia;
      if (mes < 10) mes = "0" + mes;
      this.todayDate = ano + "-" + mes + "-" + dia;

      // this.$emit("update:dateFill", this.todayDate);
      this.$emit("update:dateBegin", this.todayDate);
      this.$emit("update:dateEnd", `${this.todayDate}T23:59:59`);
    },
    onChange(value) {
      this.filterDate.optionFilterDate = value;
      if (value == 2) this.getTodayDate();
    },
  },
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.filterDate {
  margin-left: 0px;
  margin-right: 0px;
}
.fieldDate {
  margin-bottom: 10px;
}
.dateIndividual {
  margin-top: 0px;
}
.todayDate {
  text-align: center;
}
</style>
